import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  IShareFeedItemModalProps,
  ShareFeedItemModal,
} from '../components/ShareFeedItemModal'
import {
  IShareFeedItemState,
  selectShareItem,
  shareActionCreators,
} from '../modules/feedItems'

export default connect(
  (state: ApplicationState, ownProps: IShareFeedItemModalProps) =>
    createStructuredSelector<ApplicationState, IShareFeedItemState>({
      shareItem: selectShareItem(ownProps.feedItemId),
    }),
  shareActionCreators,
)(ShareFeedItemModal)
